module.exports = __webpack_public_path__ + "static/media/pin.b4666327.svg";